import type { FaireProductEntity } from "../../entity_types/product";

export const p_uwftpnhyth: FaireProductEntity = {
  token: "p_uwftpnhyth",
  type: "product",
  name: "Contrast midi dress",
  brandToken: "b_e4qxjs0kym",
  brandName: "amente",
  imageUrl: "https://cdn.faire.com/fastly/1c568dde6a4b5d1754d8340500858c61ab9216cdc10f05585f7554f41aad567c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/226bbbceee2aaa0efdb18cd1ada5d12e3356102d7bb4b2540359aed8168e9f79.jpeg",
    "https://cdn.faire.com/fastly/92d34bed82fd7441ccd06530ba5c5010ab66e2fc4e75c7837bfca51514ed14d7.jpeg",
    "https://cdn.faire.com/fastly/aa2cfe646c3332475ef39931f066038787c1a2c627d18b40ed2646d69429e00d.jpeg",
    "https://cdn.faire.com/fastly/f780413b2223d1eb0f57d8c73d355dbd4abcf0d60f2aa85c092b79fcaf88b9de.jpeg",
    "https://cdn.faire.com/fastly/12350fcf9d5bbc3b316b454d5fd0ec675e1e0c66b85ad9e776a2c14624a8561e.jpeg",
    "https://cdn.faire.com/fastly/f9b7cd0cc4c4e0093acc2235d11605d3cbb20396fa43fdcc82a530837315c7a9.jpeg",
    "https://cdn.faire.com/fastly/a16acbd9487baf409c77353b66a262b78c9030637ce8f90d5deb31c097ed81fd.jpeg",
    "https://cdn.faire.com/fastly/7606c79abcb17a4ca0850829d3110cb8f88285e2a6fed6121a220d4375217c4b.jpeg",
    "https://cdn.faire.com/fastly/87d263a188620f426674617cac65503b5594accc5978717af9b8394cbb6e1964.jpeg"
  ],
  priceDollars: 259.5,
  description: "A softly structured midi dress crafted from breathable cotton, featuring a thoughtful mix of contrasting plaid panels.\nThe bodice is clean and minimal with delicate straps, while the gathered skirt creates gentle volume and movement.\nEach panel brings a subtle shift in tone and scale, giving the piece a quiet depth without overwhelming the silhouette.\nLightweight and easy to wear, it’s designed for everyday moments—simple, comfortable, and considered.\n\nDetail\n\n• Contrast plaid paneling\n• Adjustable strap fit\n• Gathered midi-length skirt\n• Side pockets",
  tags: [],
  msrpDollars: 519,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:50.855Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
